import React from 'react';
import shallowCompare from '../../lib/shallowCompare';
import MarketingRegisterModal from '../../components/MarketingRegisterModal';
import styles from './index.sass';
import CheckmarkPng from '../../components/images/checkmark_large.png';
import CheckmarkSvg from '../../components/images/checkmark_large.svg';
import AudiencePng from './images/audience.png';
import AudienceSvg from './images/audience.svg';
import ComingBackPng from './images/coming_back.png';
import ComingBackSvg from './images/coming_back.svg';
import CustomersPng from './images/customers.png';
import CustomersSvg from './images/customers.svg';
import PlatformsJpg from './images/platforms.jpg';
import PlatformsJpg2x from './images/platforms_2x.jpg';

class MarketingPricingContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      invalidEmailEntered: false,
      showMarketingRegisterModal: false,
      selectedPlan: null
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  handleOnClickSelectPlan(plan) {
    this.setState({
      showMarketingRegisterModal: true,
      selectedPlan: plan
    });
  }

  handleOnCloseMarketingRegisterModal() {
    this.setState({showMarketingRegisterModal: false});
  }

  submitContactForm(requireEmail) {
    if(!requireEmail || (this.state.email && this.state.email.match(/.@./))) {
      this.setState({showMarketingRegisterModal: true});
    } else {
      this.setState({invalidEmailEntered: true});
    }
  }

  handleOnChangeEmail(e) {
    this.setState({
      email: e.target.value,
      invalidEmailEntered: false
    });
  }

  handleOnClickGetStarted(requireEmail, e) {
    e.stopPropagation();
    e.preventDefault();

    this.submitContactForm(requireEmail);
  }

  handleOnSubmitSignupForm(e) {
    e.stopPropagation();
    e.preventDefault();

    this.submitContactForm(true);
  }

  renderMarketingRegisterModal() {
    if(!this.state.showMarketingRegisterModal) {return;}
    let props = {
      email: this.state.email,
      plan: this.state.selectedPlan,
      onClose: this.handleOnCloseMarketingRegisterModal.bind(this)
    };
    return <MarketingRegisterModal {...props} />;
  }

  render() {
    let checkmark = <img src={CheckmarkPng} srcSet={CheckmarkSvg} />;
    let signUpFormProps = {
      onSubmit: this.handleOnSubmitSignupForm.bind(this)
    };
    let emailInputProps = {
      className: this.state.invalidEmailEntered ? styles.invalid : null,
      type: 'email',
      placeholder: 'Enter your email',
      onChange: this.handleOnChangeEmail.bind(this)
    };
    let getStartedButtonProps = {
      type: 'submit',
      onClick: this.handleOnClickGetStarted.bind(this, true)
    };
    return (
      <div className={styles.container}>
        <div className={styles.whiteSection}>
          <div className={styles.inner} style={{overflow: 'hidden'}}>
            <h2 className={styles.topHeader}><strong>Effortless web and mobile commerce</strong><strong> for the beverage industry</strong></h2>
            <h3 className={styles.subheader}>Give every customer a personalized shopping experience across all channels</h3>
            <button className={styles.getStartedButton} onClick={this.handleOnClickGetStarted.bind(this, false)}>Get started</button>
            <img className={styles.headerImage} src={PlatformsJpg} srcSet={`${PlatformsJpg} 1x, ${PlatformsJpg2x} 2x`} />
            <div className={styles.imageSubtext}>
              <p className={styles.left}>Sell on <strong>Android</strong> and <strong>iOS</strong> apps</p>
              <p className={styles.right}>Sell via email</p>
              <p className={styles.center}>Sell on web</p>
              <p className={styles.mobileOnly}>Sell on Android, iOS, web and email</p>
            </div>
          </div>
        </div>
        <div className={styles.greySection}>
          <div className={styles.inner}>
            <div className={styles.featureCard}>
              <img className={styles.icon} src={AudiencePng} srcSet={AudienceSvg} />
              <h4 className={styles.title}>Reach new audiences</h4>
              <p className={styles.text}>Seamlessly sell your products via Delectable, Wine Searcher, Google Products and more</p>
            </div>
            <div className={styles.featureCard}>
              <img className={styles.icon} src={CustomersPng} srcSet={CustomersSvg} />
              <h4 className={styles.title}>Understand your customers</h4>
              <p className={styles.text}>Advanced user insights automatically feature the right products to the right customers</p>
            </div>
            <div className={styles.featureCard}>
              <img className={styles.icon} src={ComingBackPng} srcSet={ComingBackSvg} />
              <h4 className={styles.title}>Keep them coming back</h4>
              <p className={styles.text}>Self-optimizing engagement tools to increase customer loyalty </p>
            </div>
          </div>
        </div>
        <div className={styles.whiteSection}>
          <div className={styles.inner}>
            <h1 className={styles.header}>Start your trial today and let us show you the results</h1>
            <p className={styles.description}>With Banquet, you’ll get the total ecommerce solution. Our trial period gives you a glimpse at the potential we have to offer. Before you know it, you’ll see the impact Banquet has on your business: new customers, easier website navigation, a web platform optimized for mobile devices, and of course, the power of the amazing community within our mobile app, Delectable.</p>
          </div>
        </div>
        <div className={styles.greySection}>
          <div className={styles.inner}>
            <h1 className={styles.header} style={{fontWeight: 400}}>Getting started is simple</h1>
            <h3 className={styles.subheader}>We’ll work with you to quickly get your store online and out into the world. With just a few pieces of information, we’ll have you ready to go.</h3>
            <div className={styles.plans}>
              <div className={styles.leftPlan}>
                <p className={styles.planName}>Partners</p>
                <p className={styles.value}>From $500</p>
                <p className={styles.subtext}>monthly <br />(depending on SKUs)</p>
                <p className={styles.value}>2.9% + 30¢</p>
                <p className={styles.subtext}>credit card and transaction fee</p>
                <button className={styles.selectPlanButton} onClick={this.handleOnClickSelectPlan.bind(this, 'standard')}>Get Started</button>
              </div>
              <div className={styles.rightPlan}>
                <p className={styles.planName}>Enterprise</p>
                <p className={styles.enterpriseExlpain}>Looking for something customized to your shop? We’ll be happy to discuss.</p>
                <br />
                <button className={styles.contactUsButton} onClick={this.handleOnClickSelectPlan.bind(this, 'enterprise')}>Contact us</button>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.whiteSection}>
          <div className={styles.inner}>
            <p className={styles.sectionHeader}>Compare plans</p>
            <table className={styles.featuresTable}>
              <tbody>
                <tr className={styles.headerRow}>
                  <td>Features</td>
                  <td>Partner</td>
                  <td>Enterprise</td>
                </tr>
                <tr>
                  <td>Number of products</td>
                  <td>Up to 1000</td>
                  <td>Unlimited</td>
                </tr>
                <tr>
                  <td>SSL certificate</td>
                  <td>{checkmark}</td>
                  <td>{checkmark}</td>
                </tr>
                <tr>
                  <td>PCI-Level 1 compliant credit card processing</td>
                  <td>{checkmark}</td>
                  <td>{checkmark}</td>
                </tr>
                <tr>
                  <td>Inventory management</td>
                  <td>{checkmark}</td>
                  <td>{checkmark}</td>
                </tr>
                <tr>
                  <td>Automated merchandising</td>
                  <td>{checkmark}</td>
                  <td>{checkmark}</td>
                </tr>
                <tr>
                  <td>Order management</td>
                  <td>{checkmark}</td>
                  <td>{checkmark}</td>
                </tr>
                <tr>
                  <td>Website</td>
                  <td>{checkmark}</td>
                  <td>{checkmark}</td>
                </tr>
                <tr>
                  <td>iOS and Android Storefront</td>
                  <td>{checkmark}</td>
                  <td>{checkmark}</td>
                </tr>
                <tr>
                  <td>Custom domain</td>
                  <td></td>
                  <td>{checkmark}</td>
                </tr>
                <tr className={styles.headerRow}>
                  <td>Reach New Audience</td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>SEO-Optimized Site</td>
                  <td>{checkmark}</td>
                  <td>{checkmark}</td>
                </tr>
                <tr>
                  <td>Sell on Delectable</td>
                  <td>{checkmark}</td>
                  <td>{checkmark}</td>
                </tr>
                <tr>
                  <td>Sell on Google Products</td>
                  <td>{checkmark}</td>
                  <td>{checkmark}</td>
                </tr>
                <tr>
                  <td>Optimized Google Adwords campaigns</td>
                  <td>{checkmark}</td>
                  <td>{checkmark}</td>
                </tr>
                <tr className={styles.headerRow}>
                  <td>Customer Insights & Engagement</td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>Order, search and wishlist history on all customers</td>
                  <td>{checkmark}</td>
                  <td>{checkmark}</td>
                </tr>
                <tr>
                  <td>Enriched customer profiles</td>
                  <td>{checkmark}</td>
                  <td>{checkmark}</td>
                </tr>
                <tr>
                  <td>Easily share products & collections</td>
                  <td>{checkmark}</td>
                  <td>{checkmark}</td>
                </tr>
                <tr>
                  <td>Customizable promotions</td>
                  <td>{checkmark}</td>
                  <td>{checkmark}</td>
                </tr>
                <tr className={styles.buttonRow}>
                  <td></td>
                  <td><button className={styles.selectPlanButton} onClick={this.handleOnClickSelectPlan.bind(this, 'partner')}>Choose plan</button></td>
                  <td><button className={styles.selectPlanButton} onClick={this.handleOnClickSelectPlan.bind(this, 'enterprise')}>Contact us</button></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div className={styles.whiteSection}>
          <div className={styles.customersList} />
          <button className={styles.getStartedButton} onClick={this.handleOnClickGetStarted.bind(this, false)}>Get started</button>
          <div className={styles.signupSection}>
            <form {...signUpFormProps}>
              <input {...emailInputProps} />
              <button {...getStartedButtonProps}>Get started</button>
            </form>
          </div>
        </div>
        {this.renderMarketingRegisterModal()}
      </div>
    );
  }
}

export default MarketingPricingContainer;



// WEBPACK FOOTER //
// banquet/containers/MarketingPricingContainer/index.js